import DateFnsUtils from "@date-io/date-fns";
import { Box, makeStyles, MenuItem, Typography } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Moment from "moment";

import { Alert } from "@material-ui/lab";
import { useSelector } from "react-redux";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
  },
  formContent: {
    padding: theme.spacing(1),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

export default function PurchaseJobFormComponent({
  handleSubmit,
  formValues = {
    PR_TYPE: "",
    REF_PR_NO: "",
    PR_VENDOR: "",
    PR_COMPIDX_NAME: "",
    PR_COUNTRY_NAME: "",
    PR_NO: "",
    PR_YEAR: "",
    PR_STATUS: "",
    CREATED_DATE: "",
    EMAIL: "",
    PR_COMPIDX: "",
    PR_CURRENCY: "",
    REF_CODE_PR: "",
    CREATED_NAME: "",
    TELEPHONE: "",
    APPROVE_BY: "",
    APPROVE_DATE: "",
    REMARK: "",
    REMARK_JOB: "",
  },
}) {
  const classes = useStyles();
  const form = useRef();

  const {
    result: { company },
  } = useSelector((state) => state.loginReducer);

  const { allBrands, allDepartments } = useSelector(
    (state) => state.referenceReducer
  );

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }
    return () => {};
  }, []);

  const renderBrandName = (data) => {
    if (allBrands.isLoading) {
      return <>{"Loading..."}</>;
    }

    const result = _.find(allBrands.data, {
      REF_ID: data,
    });

    if (result) {
      return result.REF_NAME;
    }
    return "";
  };
  const renderDepartmentName = (data) => {
    if (allDepartments.isLoading) {
      return <>{"Loading..."}</>;
    }

    const result = _.find(allDepartments.data, {
      REF_ID: data,
    });

    if (result) {
      return result.REF_NAME;
    }
    return "";
  };

  return (
    <div className={classes.root}>
      <Box display="flex" flexDirection="column">
        <Box>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Formik
              ref={form}
              enableReinitialize
              initialValues={{
                ...formValues,
                PR_TYPE: formValues.PR_TYPE ? formValues.PR_TYPE : null,
                REF_PR_NO: formValues.REF_PR_NO ? formValues.REF_PR_NO : null,
                PR_VENDOR: formValues.PR_VENDOR ? formValues.PR_VENDOR : null,
                PR_COMPIDX_NAME: company,
                PR_NO: formValues.PR_NO ? formValues.PR_NO : null,
                PR_YEAR: formValues.PR_YEAR ? formValues.PR_YEAR : null,
                PR_STATUS: formValues.PR_STATUS ? formValues.PR_STATUS : null,
                CREATED_DATE: formValues.CREATED_DATE
                  ? formValues.CREATED_DATE
                  : "",
                POSTED_EMAIL: formValues.POSTED_EMAIL
                  ? formValues.POSTED_EMAIL
                  : "",
                PR_COMPIDX: formValues.PR_COMPIDX ? formValues.PR_COMPIDX : "",
                PR_CURRENCY: formValues.PR_CURRENCY
                  ? formValues.PR_CURRENCY
                  : "",
                REF_CODE_PR: formValues.REF_CODE_PR
                  ? formValues.REF_CODE_PR
                  : "",
                CREATED_NAME: formValues.CREATED_NAME
                  ? formValues.CREATED_NAME
                  : "",
                ASSIGN_APPROVE_NAME: formValues.ASSIGN_APPROVE_NAME
                  ? formValues.ASSIGN_APPROVE_NAME
                  : "",
                APPROVED_DATE: formValues.APPROVED_DATE
                  ? formValues.APPROVED_DATE
                  : "",
                REMARK: formValues.REMARK ? formValues.REMARK : "",
                REMARK_JOB: formValues.REMARK_JOB ? formValues.REMARK_JOB : "",
                PR_BRANDID: formValues.PR_BRANDID ? formValues.PR_BRANDID : "",
                PR_BRAND_NAME: formValues.PR_BRANDID
                  ? renderBrandName(formValues.PR_BRANDID)
                  : "",
                PR_DEPARTID: formValues.PR_DEPARTID
                  ? formValues.PR_DEPARTID
                  : "",
                PR_DEPART_NAME: formValues.PR_DEPARTID
                  ? renderDepartmentName(formValues.PR_DEPARTID)
                  : "",
                CREATED_SHOW_DATE: formValues.CREATED_DATE
                  ? formValues.CREATED_DATE
                  : "",
                APPROVED_SHOW_DATE: formValues.APPROVED_DATE
                  ? formValues.APPROVED_DATE
                  : "",
                ASSIGN_SHOW_DATE: formValues.ASSIGN_DATE
                  ? formValues.ASSIGN_DATE
                  : "",
                REQUIRE_CONTRACT: formValues.REQUIRE_CONTRACT
                  ? formValues.REQUIRE_CONTRACT
                  : 0,
              }}
              validate={(values) => {
                const errors = {};

                return errors;
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                setTimeout(() => {
                  setSubmitting(false);
                  resetForm({});
                }, 500);
              }}
              render={({
                submitForm,
                isSubmitting,
                setSubmitting,
                touched,
                errors,
                values,
                setFieldValue,
              }) => (
                <Form className={classes.formContent}>
                  <Box>
                    <Alert icon={false} variant="filled" severity="info">
                      <Typography component="h2">
                        Purchase Requisition information
                      </Typography>
                    </Alert>
                    <Field
                      component={TextField}
                      name="PR_TYPE"
                      label="Document Status"
                      select
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    >
                      <MenuItem value={1}>New PR</MenuItem>
                      <MenuItem value={2}>Refered PR</MenuItem>
                    </Field>
                    <Field
                      component={TextField}
                      name="REF_PR_NO"
                      label="REFERENCE PR NO."
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="PR_VENDOR"
                      label="Type"
                      select
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    >
                      <MenuItem value={10} selected>
                        PREFER VENDOR
                      </MenuItem>
                      <MenuItem value={20}>COMPARE PRICE</MenuItem>
                      <MenuItem value={30}>BIDDING</MenuItem>
                    </Field>
                    <Field
                      component={TextField}
                      name="PR_COMPIDX_NAME"
                      label="Company"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="PR_YEAR"
                      label="Year"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="PR_NO"
                      label="PR NO."
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="PR_STATUS"
                      label="Status"
                      select
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    >
                      <MenuItem value={5}>New PR</MenuItem>
                      <MenuItem value={10}>DRAFT</MenuItem>
                      <MenuItem value={20}>POST</MenuItem>
                      <MenuItem value={22}>Reviewed</MenuItem>
                      <MenuItem value={24}>Rejected By Reviewer</MenuItem>
                      <MenuItem value={26}>Held By Reviewer</MenuItem>
                      <MenuItem value={30}>APPROVED</MenuItem>
                      <MenuItem value={35}>HELD BY APPROVER</MenuItem>
                      <MenuItem value={40}>REJECTED BY APPROVER</MenuItem>
                      <MenuItem value={50}>PURCHASING IN PROGRESS</MenuItem>
                      <MenuItem value={49}>CONTRACT IS REQUIRED</MenuItem>
                      <MenuItem value={51}>VERIFIED PR</MenuItem>
                      <MenuItem value={52}>LEGAL MAKES A DECISION</MenuItem>
                      <MenuItem value={53}>CONTRACT IS NOT REQUIRED</MenuItem>
                      <MenuItem value={54}>LEGAL IN PROGRESS</MenuItem>
                      <MenuItem value={55}>
                        FINAL DRAFT IS DONE AND READY TO SIGN OFF
                      </MenuItem>
                      <MenuItem value={56}>CONTRACT IS ATTACHED</MenuItem>
                      <MenuItem value={57}>LEGAL TASK IS COMPLETED</MenuItem>
                      <MenuItem value={58}>CONTRACT IS REJECTED</MenuItem>
                      <MenuItem value={59}>HELD BY LEGAL</MenuItem>
                      <MenuItem value={60}>PURCHASING COMPLETED</MenuItem>
                      <MenuItem value={70}>PURCHASING HOLD</MenuItem>
                      <MenuItem value={80}>PURCHASING REJECTED</MenuItem>
                    </Field>
                    <Field
                      component={TextField}
                      name="CREATED_SHOW_DATE"
                      label="Request Date"
                      className={classes.inputForm}
                      value={Moment(values.CREATED_SHOW_DATE).format(
                        "DD-MMM-YY"
                      )}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="REQUIRE_CONTRACT"
                      label="Contract Type"
                      select
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    >
                      <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Field>
                    <Field
                      component={TextField}
                      name="REMARK"
                      label="Remark"
                      multiline
                      style={{
                        width: "100%",
                        backgroundColor: "#D3D3D3",
                      }}
                      rows={4}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="outlined"
                    />
                  </Box>
                  <div>
                    <Alert icon={false} variant="filled" severity="info">
                      <Typography component="h2">
                        User request profile
                      </Typography>
                    </Alert>
                    <Field
                      component={TextField}
                      name="CREATED_NAME"
                      label="Created By"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="CREATED_EMAIL"
                      label="Created E-mail"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="POSTED_NAME"
                      label="Posted By"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="POSTED_EMAIL"
                      label="Posted E-mail"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="PR_BRAND_NAME"
                      label="Brand"
                      className={classes.inputForm}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="PR_DEPART_NAME"
                      label="Department"
                      className={classes.inputForm}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                  </div>
                  <div>
                    <Alert icon={false} variant="filled" severity="info">
                      <Typography component="h2"> Purchasing staff</Typography>
                    </Alert>
                    <Field
                      component={TextField}
                      name="REVIEWER_NAME"
                      label="Reviewed By"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="REVIEWER_REVIEWED_DATE"
                      label="Reviewed Date"
                      className={classes.inputForm}
                      value={Moment.utc(values.REVIEWER_REVIEWED_DATE)
                        .local("Asia/Bangkok")
                        .format("DD-MMM-YY")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="ASSIGN_APPROVE_NAME"
                      label="Approve By"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="APPROVED_SHOW_DATE"
                      label="Approved Date"
                      className={classes.inputForm}
                      value={Moment(values.APPROVED_SHOW_DATE).format(
                        "DD-MMM-YY"
                      )}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="ASSIGN_PURCHASE_NAME"
                      label="Assignee"
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                    />
                    <Field
                      component={TextField}
                      name="ASSIGN_SHOW_DATE"
                      label="Assigned Date"
                      className={classes.inputForm}
                      value={Moment(values.ASSIGN_SHOW_DATE).format(
                        "DD-MMM-YY"
                      )}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      style={{
                        backgroundColor: "#D3D3D3",
                      }}
                      size="small"
                    />
                    {values.REMARK_JOB && (
                      <Field
                        component={TextField}
                        name="REMARK_JOB"
                        label="Remark Job"
                        multiline
                        style={{
                          width: "100%",
                        }}
                        rows={4}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        variant="outlined"
                      />
                    )}
                  </div>
                </Form>
              )}
            />
          </MuiPickersUtilsProvider>
        </Box>
      </Box>
    </div>
  );
}
